package com.wintermar.inspection.core.ui.component.image

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.component.image.util.FileModel

@Composable
actual fun ImagePickerModal(
    title: String,
    description: String,
    files: List<FileModel>,
    show: Boolean,
    onDismiss: () -> Unit,
    onSave: (List<FileModel>) -> Unit
) {
    ImagePickerDialog(
        title = title,
        description = description,
        files = files,
        show = show,
        onDismiss = onDismiss,
        onSave = onSave
    )
}
